import React, { FC } from 'react';

import { Grid } from '@chakra-ui/react';

import { MetadataCommonFields } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/Components/MetadataCommonFields';
import { useActiveResourceContext } from 'containers/ActiveCloudResource/hooks/context/context';

import {
  AgentCoreGatewayAuthorizerType,
  AgentCoreGatewayCustomTransformLambdaARN,
  AgentCoreGatewayKMSKeyARN,
  AgentCoreGatewayPolicyEngineARN,
  AgentCoreGatewayPolicyEngineMode,
  AgentCoreGatewayProtocolType,
  AgentCoreGatewayTargetMCPLambdaARNs,
  AgentCoreGatewayTargetNames,
  AgentCoreGatewayTargetProtocolTypes,
  AgentCoreGatewayTargetRuntimeARNs,
  AgentCoreGatewayTargetStatuses,
  AgentCoreGatewayURL,
  AgentCoreGatewayWebACLARN,
  IAMRoleARN,
} from '../../../../Components/MetadataField/MetaGridFields';

export const AWSBedrockAgentCoreGatewayMetadata: FC = () => {
  const { resourceDetails, resourceInsight } = useActiveResourceContext();
  const { data: resource } = resourceDetails;
  const { data: insight } = resourceInsight;
  const metadata = { ...resource, ...insight };

  return (
    <Grid templateColumns="repeat(4, 1fr)" gap={4}>
      <MetadataCommonFields
        state={metadata}
        availabilityZone="None"
        cloudId="None"
        vpc="None"
        owner="None"
        createdAt={metadata}
        updatedAt={metadata}
      />
      {AgentCoreGatewayProtocolType(metadata)}
      {AgentCoreGatewayAuthorizerType(metadata)}
      {AgentCoreGatewayURL(metadata)}
      {AgentCoreGatewayPolicyEngineARN(metadata)}
      {AgentCoreGatewayPolicyEngineMode(metadata)}
      {AgentCoreGatewayCustomTransformLambdaARN(metadata)}
      {AgentCoreGatewayTargetNames(metadata)}
      {AgentCoreGatewayTargetStatuses(metadata)}
      {AgentCoreGatewayTargetProtocolTypes(metadata)}
      {AgentCoreGatewayTargetRuntimeARNs(metadata)}
      {AgentCoreGatewayTargetMCPLambdaARNs(metadata)}
      {IAMRoleARN(metadata)}
      {AgentCoreGatewayKMSKeyARN(metadata)}
      {AgentCoreGatewayWebACLARN(metadata)}
    </Grid>
  );
};
